import { FC } from "react";
import { MatchWithYourCompanyContainer } from "./styles";
import { TypographH2, TypographSpan } from "../typograph";
import { colors } from "~/constants/colors";
import Link from "next/link";
import { RoutesEnum } from "~/enums/routes";

export const MatchWithYourCompany: FC = () => {
  return (
    <MatchWithYourCompanyContainer>
      <TypographH2
        bold
        color={colors.green}
        uppercase
        letterSpacing={6}
        lineHeight={28.8}
        size={24}
      >
        combina com a sua empresa?
      </TypographH2>

      <TypographSpan
        weak
        size={14}
        lineHeight={22.4}
        color={colors.text_white}
        letterSpacing={4}
        uppercase
      >
        estamos aqui para te ajudar a impulsionar seu negócio e trazer
        resultados
      </TypographSpan>

      <Link href={RoutesEnum.contact}>
        <TypographSpan
          uppercase
          bold
          color={colors.black}
          size={12}
          letterSpacing={5}
          lineHeight={16.8}
        >
          entre em contato
        </TypographSpan>
      </Link>
    </MatchWithYourCompanyContainer>
  );
};
